import { CLEAR_DATA, EQUITY_HOLDING_LIVE_NEWS, LIVE_NEWS, LIVE_NEWS_ERROR, LIVE_NEWS_HIDE_ERROR, LIVE_NEWS_START_LOADER, LIVE_NEWS_STOP_LOADER, LIVE_NEWS_STREAM, QOUTE_STREAM_NEWS, RESET_STREAM_COUNT, } from "../interface/iLiveNewsReducer";
import store from "@redux/store";
var LiveNewsActions = /** @class */ (function () {
    function LiveNewsActions() {
        this.dispatch = store.dispatch;
    }
    LiveNewsActions.prototype.resetCount = function () {
        this.dispatch({
            type: RESET_STREAM_COUNT,
        });
    };
    LiveNewsActions.prototype.getNewsStreamData = function (payload) {
        this.dispatch({
            type: QOUTE_STREAM_NEWS,
            payload: { qouteStream: payload },
        });
    };
    LiveNewsActions.prototype.getLiveNewsStreamData = function (payload) {
        this.dispatch({
            type: LIVE_NEWS_STREAM,
            payload: { liveNewsData: payload },
        });
    };
    LiveNewsActions.prototype.getLiveNewsData = function (data) {
        this.dispatch({
            type: LIVE_NEWS,
            payload: { data: data },
        });
    };
    LiveNewsActions.prototype.getEquityHoldingLiveNews = function (data) {
        this.dispatch({
            type: EQUITY_HOLDING_LIVE_NEWS,
            payload: { data: data },
        });
    };
    LiveNewsActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: LIVE_NEWS_ERROR,
            payload: { errorData: payload },
        });
    };
    LiveNewsActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: LIVE_NEWS_HIDE_ERROR,
        });
    };
    LiveNewsActions.prototype.setStartLiveNewsLoader = function () {
        this.dispatch({
            type: LIVE_NEWS_START_LOADER,
        });
    };
    LiveNewsActions.prototype.setStopLiveNewsLoader = function () {
        this.dispatch({
            type: LIVE_NEWS_STOP_LOADER,
        });
    };
    LiveNewsActions.prototype.clearData = function () {
        this.dispatch({
            type: CLEAR_DATA,
        });
    };
    return LiveNewsActions;
}());
export default LiveNewsActions;
